
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class SecurityMatchRulesetRuleGrid extends SiteEntityGrid<SecurityMatchRulesetRuleRow, any> {
        protected getColumnsKey() { return 'Data.SecurityMatchRulesetRule'; }
        protected getDialogType() { return SecurityMatchRulesetRuleDialog; }
        protected getIdProperty() { return SecurityMatchRulesetRuleRow.idProperty; }
        protected getInsertPermission() { return SecurityMatchRulesetRuleRow.insertPermission; }
        protected getLocalTextPrefix() { return SecurityMatchRulesetRuleRow.localTextPrefix; }
        protected getService() { return SecurityMatchRulesetRuleService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}